import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { StyledApp } from './StyledApp'
import loadable from '@loadable/component'
import { withRouter } from 'react-router-dom'
import { venture } from '../../../config'
import { styles } from './theme'

const Cookie = loadable(() => import('@albatross/common-components/dist/components/Cookie'))
const ventureStyles = styles[venture] ? styles[venture] : styles.default

const PageTemplate = (props) => {
  const { children, location, components, globalContent } = props
  let isNavMenuPresent = false

  useEffect(() => {
    !location.hash && window.scrollTo(0, 0)
  }, [location])

  components?.length && components.forEach((component) => {
    if (component.type === 'UnicornNavigationMenu' || component.type === 'NavigationMenu') {
      isNavMenuPresent = true
    }
  })

  return (
    <StyledApp
      id="styledApp"
      styles={ventureStyles}
      isNavMenuPresent={isNavMenuPresent}
    >
      {children}
      <Cookie cookie={globalContent?.cookie} />
    </StyledApp>
  )
}

PageTemplate.propTypes = {
  children: PropTypes.any.isRequired,
  location: PropTypes.object,
  components: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      props: PropTypes.object
    })
  ),
  globalContent: PropTypes.object
}

export default withRouter(PageTemplate)
